<script setup lang="ts">
import {TimelineEntryConfig} from "@/hospital/services/HospitalTimelineService";
import {HospitalMessageHospitalTimelineEntry} from "@/hospital/interfaces/hospital-timeline";
import HospitalTimelineBaseEntry from "@/hospital/components/timeline/HospitalTimelineBaseEntry.vue";

interface Props {
    entry: HospitalMessageHospitalTimelineEntry
    config: TimelineEntryConfig
}

defineProps<Props>();
</script>

<template>
  <HospitalTimelineBaseEntry :entry="entry" :config="config" :chat-bubble="true">
    <template #user-info>
      <p
        v-if="entry.entryable.sender?.name"
        class="text-xs text-gray-600"
      >
        par {{ entry.entryable.sender?.name }}
      </p>
    </template>
  </HospitalTimelineBaseEntry>
</template>
